import { Link } from 'react-router-dom';

type ProgressBulletsProps = {
  steps: {
    name: string;
    href: string;
    status: 'complete' | 'current' | 'upcoming';
  }[];
  // using react router links we can pass the state to the next route
};

export function ProgressBullets(props: ProgressBulletsProps) {
  const { steps } = props;

  return (
    <nav aria-label="Progress" className="flex items-center justify-center gap-4">
      <p className="text-sm font-medium">
        Step {steps.findIndex((step) => step.status === 'current') + 1} of {steps.length}
      </p>
      <ol role="list" className="ml-8 flex items-center space-x-5">
        {steps.map((step) => (
          <li key={step.name}>
            {step.status === 'complete' ? (
              <Link
                to={step.href}
                className="block size-2.5 rounded-full bg-primary hover:bg-accent"
              >
                <span className="sr-only">{step.name}</span>
              </Link>
            ) : step.status === 'current' ? (
              <div aria-current="step" className="relative flex items-center justify-center">
                <span aria-hidden="true" className="absolute flex size-5 p-px">
                  <span className="size-full rounded-full bg-indigo-200" />
                </span>
                <span
                  aria-hidden="true"
                  className="relative block size-2.5 rounded-full bg-primary"
                />
                <span className="sr-only">{step.name}</span>
              </div>
            ) : (
              <div className="block size-2.5 rounded-full bg-gray-200 hover:bg-gray-400">
                <span className="sr-only">{step.name}</span>
              </div>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
}
